
{
  "fr": {
    "BirthdateRepeatableField": {
      "add": "Ajouter un anniversaire…"
    }
  }
}
